import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import cn from "classnames";
import { TypographyTags } from "./TypographyTypes";
import { Alignments } from "../../core";

var Typography = function Typography(_ref) {
  var _cn;

  var align = _ref.align,
      children = _ref.children,
      type = _ref.type,
      tag = _ref.tag,
      boldness = _ref.boldness,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className;
  var getClassName = getClassNameFactory(Typography.displayName);
  return /*#__PURE__*/React.createElement(tag, {
    className: cn(className, getClassName({
      modifiers: cn((_cn = {}, _defineProperty(_cn, type, true), _defineProperty(_cn, align, true), _defineProperty(_cn, boldness, Boolean(boldness)), _cn))
    }))
  }, children);
};

Typography.displayName = "Typography";
Typography.defaultProps = {
  tag: TypographyTags.DIV,
  align: Alignments.LEFT
};
export default Typography;